import { useTranslation } from 'react-i18next';
import { fetchAddressSuggestions, resolveAddressSuggestionLocation } from '../../api';
import type { OrderLocation } from '../../types';
import SharedAddressAutocomplete, {
  type AddressAutocompleteSource,
} from '../../../miniapp/ui-kit/AddressAutocomplete';

const websiteAddressSource: AddressAutocompleteSource = {
  fetchSuggestions: fetchAddressSuggestions,
  resolveLocation: resolveAddressSuggestionLocation,
};

interface AddressAutocompleteProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onLocationChange: (location: OrderLocation | null) => void;
  placeholder?: string;
}

export default function AddressAutocomplete(props: AddressAutocompleteProps) {
  const { t } = useTranslation();

  return (
    <SharedAddressAutocomplete
      {...props}
      source={websiteAddressSource}
      loadingLabel={t('website.addressAutocomplete.loadingSuggestions')}
      inputClassName="rounded-xl bg-secondary"
      listClassName="top-[calc(100%+6px)] max-h-[240px] rounded-xl shadow-ambient"
    />
  );
}
